import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate } from "react-router";
import Loader from "../../control-components/loader/loader";
import APP_ROUTES from "../../helper/app-routes";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { useSelector } from "react-redux";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import { Chip } from "@progress/kendo-react-buttons";
import CopyRegionTemplate from "./copy-another-region";
import AssignTemplateToClinic from "./assign-template-clinic";
import InputKendoRct from "../../control-components/input/input";
import AssignTemplateLabel from "./template-label";
import UpdateTemplate from "./update-template";
import DocumentTemplateInfo from "./document-template-info";
import { Dialog, DialogActionsBar, Window } from "@progress/kendo-react-dialogs";
import AppRoutes from "../../helper/app-routes";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function DocumentTemplate() {
    const regionData = useSelector((state) => state.getRegion);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loadingLabel, setLoadingLabel] = useState(false);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sort, setSort] = useState([]);
    const [selectedId, setSelectedId] = useState("");
    const [checkedTemplates, setCheckedTemplates] = useState([]);
    const [isAllSelected, setAllSelected] = useState(false);
    const [documentTemplateId, setDocumentTemplateId] = useState();
    const [defaulttemplates, setDefaultTemplates] = useState([]);
    const [copyRegionTemplate, setCopyRegionTemplate] = useState(false);
    const [assignTemplateSelectedId, setAssignTemplateSelectedId] = useState("");
    const [assignTemplateModule, setAssignTemplateModule] = useState(false);
    const [defaultTemplateList, setDefaultTemplateList] = useState([])
    const [searchText, setSearchText] = useState("")
    const [isAddTagOpen, setIsAddTagOpen] = useState(false)
    const [isEditTemplateOpen, setIsEditTemplateOpen] = useState(false)
    const [editSelectedData, setEditSelectedData] = useState()
    const [isOpenTemplateInfo, setIsOpenTemplateInfo] = useState(false)
    const [selectedTemplateInfo, setSelectedTemplateInfo] = useState()
    const [openedTemplateFile, setOpenedTemplateFile] = useState()
    const [selectedState, setSelectedState] = React.useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const [fields, setFields] = useState({
        regionName: {},
        searchContent: ""
    });
    const [loadingFileTemplate, setLoadingFileTemplate] = useState(false);
    const [clientBaseUrl, setClientBaseUrl] = useState('');

    useEffect(() => {
        const currentUrl = window.location.href;
        const clientAppUrlPrefix = currentUrl.includes('admin.dev') ? "notenetic-ui." : "demo.";
        let updatedUrl = currentUrl.replace('admin.', clientAppUrlPrefix);
        updatedUrl = updatedUrl.replace(AppRoutes.FILE_DOCUMENT_TEMPLATE, '');
        setClientBaseUrl(updatedUrl);
    }, []);

    useEffect(() => {
        let newObj = {
            id: regionData[0]?.id,
            regionName: regionData[0]?.regionName,
        };
        setFields({
            ...fields,
            regionName: newObj,
        });
    }, []);

    useEffect(() => {
        if (fields.regionName?.id) {
            getAllDefaultDocumentTemplates(fields?.regionName);
        }
    }, [fields?.regionName?.id]);

    const pageChange = (event) => {
        let skip = event.page.skip;
        let take = event.page.take;
        setPage(skip);
        setPageSize(take);
        setAllSelected(false)
    };

    const getAllDefaultDocumentTemplates = async (value) => {
        setLoading(true);
        if (fields) {
            await fileDocumentService
                .getAllDefaultDocumentTemplates(fields?.regionName)
                .then((result) => {
                    const sortedData = result?.resultData.sort((a, b) =>
                        a.templateName.localeCompare(b.templateName)
                    );
                    setDefaultTemplates(sortedData);
                    setDefaultTemplateList(sortedData);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    NotificationManager.error(error);
                });

        }
    };

    const handleAddDocumentTemplate = () => {
        navigate(APP_ROUTES.ADD_DOCUMENT_TEMPLATE, { state: { fields } });
    };

    const handleChange = (e) => {
        setCheckedTemplates([]);
        const name = e.target.name;
        const value = e.target.value;
        // if (name == "clinic") {
        //   GetAdminClinic(value.id);
        // }

        setFields({
            ...fields,
            [name]: value,
        });
    };

    const handleCopyRegion = (field) => {
        setSelectedId(field);
        setCopyRegionTemplate(!copyRegionTemplate);
    };

    const handleAssignTemplateToClinic = (field) => {
        setAssignTemplateSelectedId(field);
        setAssignTemplateModule(!assignTemplateModule);
    };

    const handleAddTags = (field) => {
        setIsAddTagOpen(!isAddTagOpen)
        setDocumentTemplateId(field)
    }

    const handleFilter = (e) => {
        const { name, value } = e.target;
        if (name === "searchContent") {
            if (value === "") {
                setDefaultTemplates(defaultTemplateList)
            } else {
                const filterResult = (defaultTemplateList.filter((item) =>
                (item?.templateName?.toLowerCase().includes(e.target.value.toLowerCase())
                    || item?.htmlFileName?.toLowerCase().includes(e.target.value.toLowerCase()) || item?.labelName?.toLowerCase().includes(e.target.value.toLowerCase()) || item.id.toString().includes(value))))
                setDefaultTemplates(filterResult)
                setPage(0)
            }
            setSearchText(value)
        }
    }
    const onHeaderSelectionChange = React.useCallback((event) => {
        const checked = event.syntheticEvent.target.checked;
        setAllSelected(checked);

        const selectedData = checked
            ? [...defaulttemplates]
            : [];

        setCheckedTemplates(selectedData);
    }, [defaulttemplates]);


    const handleEditTemplate = (field) => {
        setIsEditTemplateOpen(!isEditTemplateOpen)
        setEditSelectedData(field)
        setDocumentTemplateId(field?.id)

    }

    const handleSelectTemplateId = (field) => {
        setIsOpenTemplateInfo(!isOpenTemplateInfo)
        setSelectedTemplateInfo(field)
    }

    function getFileViewClick(field) {
        return () => {
            setOpenedTemplateFile(field?.htmlFileName);
            setLoadingFileTemplate(true)
        };
    }

    const onSelectionChange = (event) => {
        const item = event.dataItem;
        const isSelected = event.nativeEvent.target.checked;

        if (isSelected) {
            setCheckedTemplates((prev) => [...prev, item]);
        } else {
            setCheckedTemplates((prev) =>
                prev?.filter((t) => t?.id !== item?.id)
            );
        }
    };

    const showConfirmPopup = (templateId) => {
        setShowConfirm(true);
        setSelectedId(templateId);
    };

    const RemoveLabel = async () => {
        setLoadingLabel(true);
        await fileDocumentService
            .removeTemplateLabel(selectedId, fields.regionName?.id)
            .then((result) => {
                if (result.status) {
                    NotificationManager.success("Label removed  successfully");
                    setDefaultTemplates((prev) =>
                        prev.map((item) =>
                            item.id === selectedId
                                ? {
                                    ...item,
                                    labelName: null,
                                    labelColor: null,
                                    templateName: null,
                                }
                                : item
                        )
                    );
                }
                setLoadingLabel(false);

                hideConfirmPopup();
            })
            .catch((error) => {
                setLoadingLabel(false);
                NotificationManager.error(error);
            });
        hideConfirmPopup();
    };

    const hideConfirmPopup = () => {
        setShowConfirm(false);
        setSelectedId("");
    };

    return (
        <div>
            {openedTemplateFile && <Window
                title={`Template - ${openedTemplateFile}`}
                onClose={() => setOpenedTemplateFile(undefined)}
                initialHeight={window.innerHeight * 0.9}
                initialWidth={window.innerWidth * 0.9}
                height={window.innerHeight * 0.9}
                width={window.innerWidth * 0.9}
                style={{ overflow: 'hidden' }}
            >
                {loadingFileTemplate && <Loader />}
                <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                    <iframe
                        src={`${clientBaseUrl}/document/template/view?templateName=${openedTemplateFile}`}  // Replace with your URL
                        style={{ width: '100%', height: '100%', border: 'none' }}
                        title="Content"
                        onLoad={() => {
                            setLoadingFileTemplate(false);
                        }}
                    />
                </div>
            </Window>}
            <h4 h4 className="address-title text-grey ">
                <span className="f-24">Default Template</span>
            </h4>
            <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                <div className="col-lg-3 col-md-6 col-12 " style={{ paddingLeft: "0px", marginTop: "19px" }}>
                    <InputKendoRct
                        value={searchText}
                        onChange={handleFilter}
                        name="searchContent"
                        className="form-control"
                        placeholder={" Search"}
                    />
                </div>
                <div className="d-flex align-items-end">
                    {
                        checkedTemplates.length > 0 &&
                        <button
                            onClick={handleAddTags}
                            className="green-btn  btn-primary mr-2"
                        >
                            Assign label
                        </button>
                    }

                    <button
                        onClick={handleAssignTemplateToClinic}
                        className="green-btn  btn-primary mr-2"
                    >
                        Assign Template to Clinic
                    </button>
                    <button
                        onClick={handleAddDocumentTemplate}
                        className="green-btn  btn-primary"
                    >
                        <i className="fa fa-plus" style={{ marginRight: '5px' }}></i>
                        Add File Template
                    </button>

                    <div className="ml-3 edit-Service-popup">
                        <DropDownKendoRct
                            filterable={true}
                            label="Region"
                            onChange={handleChange}
                            data={regionData}
                            value={fields.regionName}
                            textField="regionName"
                            name="regionName"
                            dataItemKey="id"
                            suggest={true}
                        />
                    </div>
                </div>
            </div>
            <div className="grid-table  filter-grid">
                <div className=" mt-3">
                    <div className="inner-section-edit position-relative text-center">
                        <div className="grid-table  filter-grid header-blue">
                            <div className=" mt-3">
                                {loading ? <Loader /> :
                                    <Grid
                                        // style={{ height: '600px' }}
                                        scrollable="scrollable"
                                        data={orderBy(
                                            defaulttemplates?.slice(page, pageSize + page),
                                            sort
                                        ).map((item) => ({
                                            ...item,
                                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                                        }))}
                                        checkboxElement
                                        dataItemKey={DATA_ITEM_KEY}
                                        selectedField={SELECTED_FIELD}
                                        skip={page}
                                        take={pageSize}
                                        total={defaulttemplates?.length}
                                        onPageChange={pageChange}
                                        pageable={{
                                            pageSizes: [10, 20, 30],
                                        }}
                                        sort={sort}
                                        sortable={true}
                                        onSortChange={(e) => {
                                            setSort(e.sort);
                                        }}
                                        onHeaderSelectionChange={onHeaderSelectionChange}
                                        selectable={{
                                            enabled: true,
                                            checkboxOnly: true,
                                            mode: "multiple"
                                        }}
                                        onSelectionChange={onSelectionChange}
                                    >
                                        <GridNoRecords style={{}}></GridNoRecords>

                                        <GridColumn
                                            width="70px"
                                            field={SELECTED_FIELD}
                                            headerSelectionValue={isAllSelected}
                                            columnType="checkbox"
                                        />

                                        <GridColumn
                                            field="id"
                                            width="150px"
                                            title="Template ID"
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem
                                                    return <td onClick={() => handleSelectTemplateId(field)}
                                                        className="text-theme"
                                                        style={{ cursor: "pointer" }}>{field?.id}</td>;
                                                }
                                            }}
                                        />
                                        <GridColumn
                                            className="cursor-default"
                                            field="templateName"
                                            title="Template"
                                            width="350px"
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem
                                                    return <td className="cursor-default">{`${field?.templateName}`}</td>;
                                                }
                                            }}
                                        />
                                        <GridColumn
                                            className="cursor-default"
                                            field="htmlFileName"
                                            title="File Name"
                                            width="300px"
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem
                                                    return <td className="cursor-default">{`${field?.htmlFileName}`}</td>;
                                                }
                                            }}
                                        />
                                        <GridColumn
                                            className="cursor-default"
                                            field="templateTypeName"
                                            title="Template Type"
                                            width="150px"
                                        />
                                        <GridColumn
                                            className="cursor-default"
                                            title="Template Label"
                                            width="200px"
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem;

                                                    const handleRemove = () => {
                                                        showConfirmPopup(field.id);
                                                    };

                                                    return (
                                                        <td className="cursor-default">
                                                            {field?.labelName && field?.labelColor ? (
                                                                <Chip
                                                                    text={field?.labelName}
                                                                    key={field.id}
                                                                    value="chip"
                                                                    rounded={"large"}
                                                                    fillMode={"solid"}
                                                                    removable={true}
                                                                    onRemove={handleRemove}
                                                                    size={"medium"}
                                                                    style={{
                                                                        marginRight: 5,
                                                                        backgroundColor: field.labelColor,
                                                                        marginBottom: 5,
                                                                        color: "#ffffff",
                                                                    }}
                                                                />
                                                            ) : (
                                                                ""
                                                            )}
                                                        </td>
                                                    );
                                                },
                                            }}
                                        />
                                        {/* <GridColumn
                    className="cursor-default"
                    field="htmlFileName"
                    title="Master Clinic ID"
                    cell={(props) => {
                      let field = props?.dataItem?.assignedClinic?.map((item) => item?.masterClinicId)
                      return <td className="cursor-default">{`${field}`}</td>;
                    }}
                  /> */}
                                        {/* <GridColumn
                    className="cursor-default"
                    field="createdBy"
                    title="Created By"
                  /> */}
                                        {/* <GridColumn
                    className="cursor-default"
                    field="utcDateCreated"
                    title="Date Created"
                    cell={(props) => {
                      let field = moment(props.dataItem.utcDateCreated).format(
                        "MM/DD/YYYY"
                      );
                      return <td className="cursor-default">{field}</td>;
                    }}
                  /> */}
                                        {/* <GridColumn
                    className="cursor-default"
                    field="isDefault"
                    title="Is Default"
                    cell={(props) => {
                      let field = props.dataItem.isDefault;
                      return (
                        <td>
                          {field === true ? (
                            <span
                              className="fa fa-check-circle cursor-default f-18 "
                              style={{ color: "green" }}
                            ></span>
                          ) : (
                            <span
                              className="fa fa-times-circle cursor-default f-18 cross-icon-color"
                              style={{ color: "red" }}
                            ></span>
                          )}
                        </td>
                      );
                    }}
                  /> */}
                                        <GridColumn
                                            title="Action"
                                            width="200px"
                                            filterable={false}
                                            cells={{
                                                data: (props) => {
                                                    let field = props.dataItem;
                                                    return (
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', height: '100%' }}>
                                                                {field?.isHtmlFileTypeTemplate && (
                                                                    <div
                                                                        className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        onClick={() => handleCopyRegion(field)}
                                                                    >
                                                                        <div className="k-chip-content ml-0">
                                                                            <Tooltip anchorElement="target" position="top">
                                                                                <i
                                                                                    className="fa fa-clone"
                                                                                    aria-hidden="true"
                                                                                    title="Copy to Another Region"
                                                                                ></i>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green"
                                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                    onClick={() => handleEditTemplate(field)}
                                                                >
                                                                    <div className="k-chip-content ml-0">
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i
                                                                                className="fa fa-edit"
                                                                                aria-hidden="true"
                                                                                title="Edit"
                                                                            ></i>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Chip
                                                                        text="Label"
                                                                        value="chip"
                                                                        icon={"fa fa-plus"}
                                                                        rounded={"large"}
                                                                        fillMode={"solid"}
                                                                        size={"medium"}
                                                                        onClick={() => handleAddTags(field)}
                                                                        style={{
                                                                            color: '#1a73e8',
                                                                            borderColor: '#1a73e8',
                                                                            backgroundColor: '#fff',
                                                                            fontWeight: 500,
                                                                            cursor: 'pointer',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            padding: '0 10px',
                                                                            height: '32px',
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-blue"
                                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                    onClick={getFileViewClick(field)}
                                                                >
                                                                    <div className="k-chip-content  ml-0">
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i
                                                                                className="fa-regular fa-eye"
                                                                                aria-hidden="true"
                                                                                title="View"
                                                                            ></i>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    );
                                                }
                                            }}
                                        />
                                    </Grid>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {assignTemplate && (
        <AssignDocument
          onClose={handleCloseTags}
          documentTemplateId={documentTemplateId}
          regionId={fields.regionName?.id}
        />
      )} */}
            {/* {isDeleteConfirm && (
        <DeleteDialogModal
          onClose={handleClose}
          title="Document Template"
          message="document template"
          handleDelete={deleteDocumentTemplate}
        />
      )} */}
            {isAddTagOpen && (
                <AssignTemplateLabel
                    onClose={handleAddTags}
                    documentTemplateId={documentTemplateId}
                    regionId={fields.regionName?.id}
                    getAllDefaultDocumentTemplates={getAllDefaultDocumentTemplates}
                    checkedTemplates={checkedTemplates}

                />
            )}
            {copyRegionTemplate && (
                <CopyRegionTemplate
                    onClose={handleCopyRegion}
                    documentTemplateId={selectedId}
                    sourceRegionId={fields}
                />
            )}
            {assignTemplateModule && (
                <AssignTemplateToClinic
                    onClose={handleAssignTemplateToClinic}
                    documentTemplateId={assignTemplateSelectedId}
                    sourceRegionId={fields}
                    checkedTemplates={checkedTemplates}
                    getAllDefaultDocumentTemplates={getAllDefaultDocumentTemplates}

                />
            )}
            {isEditTemplateOpen && (
                <UpdateTemplate
                    onClose={handleEditTemplate}
                    regionId={fields.regionName?.id}
                    documentTemplateId={documentTemplateId}
                    editSelectedData={editSelectedData}
                    getAllDefaultDocumentTemplates={getAllDefaultDocumentTemplates}

                />
            )}
            {
                isOpenTemplateInfo && (
                    <DocumentTemplateInfo
                        onClose={handleSelectTemplateId}
                        selectedTemplateInfo={selectedTemplateInfo}
                        regionId={fields.regionName?.id}
                        getAllDefaultDocumentTemplates={getAllDefaultDocumentTemplates}

                    />
                )
            }
            {/* {
        isOpenAddLabel && (
          <AddUpdateDocumentTemplateLabel
            onClose={handleAddUpdateLabel}
          />
        )
      } */}

            {showConfirm ? (
                <Dialog
                    className="xs-modal"
                    title={"Please confirm"}
                    onClose={hideConfirmPopup}
                >
                    <p
                        style={{
                            margin: "25px",
                        }}
                    >
                        Are you sure you want to remove this label
                    </p>
                    <DialogActionsBar>

                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={RemoveLabel}
                        >
                            Yes
                        </button>

                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={hideConfirmPopup}
                        >
                            No
                        </button>
                    </DialogActionsBar>
                </Dialog>
            ) : (
                ""
            )}
        </div>
    );
}

export default DocumentTemplate;
